module.exports = __webpack_public_path__ + "img/shout.77eac0ea.png";